import {
  BadgeCheck, Users, Cpu, Wallet, MapPin, GraduationCap,
  Briefcase, Building2, Factory, HandCoins, Truck, Bus, School,
  Accessibility, RefreshCw,
} from "lucide-react";

const MAP = {
  BadgeCheck, Users, Cpu, Wallet, MapPin, GraduationCap,
  Briefcase, Building2, Factory, HandCoins, Truck, Bus, School,
  Accessibility, RefreshCw,
};

export default function Icon({ name, className = "h-6 w-6" }) {
  const Cmp = MAP[name] || BadgeCheck;
  return <Cmp className={className} />;
}
